import { render, staticRenderFns } from "./Profiletemplete.vue?vue&type=template&id=1b81bdbf&scoped=true&"
import script from "./Profiletemplete.vue?vue&type=script&lang=js&"
export * from "./Profiletemplete.vue?vue&type=script&lang=js&"
import style0 from "./Profiletemplete.vue?vue&type=style&index=0&id=1b81bdbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81bdbf",
  null
  
)

export default component.exports